import { render, staticRenderFns } from "./ActeTypeAjout.vue?vue&type=template&id=7fd44e83&"
import script from "./ActeTypeAjout.vue?vue&type=script&lang=js&"
export * from "./ActeTypeAjout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports